import { ref, type Ref } from 'vue';
import { instance as api } from '@/helpers/api';

export type TerminologyEntry = { title: string, content: string };
const pathMap: { [key: string]: Ref<TerminologyEntry[]> } = {};
const loading = ref(false);

export function useTerminologyData(path: string[]): { data: Ref<TerminologyEntry[]>, loading: Ref<boolean> } {
    const key = path.join('-');
    if (!(key in pathMap)) {
        pathMap[key] = ref([]);
        loading.value = true;
        api().get('terminology/get', {
            params: { path: path }
        }).then((res) => {
            pathMap[key].value = res?.data?.data ?? [];
        }).finally(() => {
            loading.value = false;
        });
    }
    return { data: pathMap[key], loading };
}